// consts used in GigClaimForm

export type PromoterFormItem = {
  type: "text" | "email" | "select";
  tKey: string;
  defaultValue: string;
  name: string;
};

// Translation happens at render time: use t(item.tKey, item.defaultValue)
export const PROMOTOR_FORM_ITEMS: PromoterFormItem[] = [
  {
    type: "text",
    tKey: "gigs:claim-promoter-name",
    defaultValue: "Promoter name",
    name: "promotorName",
  },
  {
    type: "text",
    tKey: "gigs:claim-promoter-address1",
    defaultValue: "Promoter address 1",
    name: "promotorAddress1",
  },
  {
    type: "text",
    tKey: "gigs:claim-promoter-street",
    defaultValue: "Promoter street",
    name: "promotorStreet",
  },
  {
    type: "text",
    tKey: "gigs:claim-promoter-city",
    defaultValue: "Promoter city",
    name: "promotorCity",
  },
  {
    type: "text",
    tKey: "gigs:claim-promoter-postcode",
    defaultValue: "Promoter postcode",
    name: "promotorPostcode",
  },
  {
    type: "select",
    tKey: "gigs:claim-promoter-country",
    defaultValue: "Promoter country",
    name: "promotorCountry",
  },
  {
    type: "text",
    tKey: "gigs:claim-promoter-phone",
    defaultValue: "Promoter phone",
    name: "promotorPhone",
  },
  {
    type: "email",
    tKey: "gigs:claim-promoter-email",
    defaultValue: "Promoter email",
    name: "promotorEmail",
  },
];

export const TIME_OPTIONS = [
  { label: "0:00 AM", value: "00:00" },
  { label: "1:00 AM", value: "01:00" },
  { label: "2:00 AM", value: "02:00" },
  { label: "3:00 AM", value: "03:00" },
  { label: "4:00 AM", value: "04:00" },
  { label: "5:00 AM", value: "05:00" },
  { label: "6:00 AM", value: "06:00" },
  { label: "7:00 AM", value: "07:00" },
  { label: "8:00 AM", value: "08:00" },
  { label: "9:00 AM", value: "09:00" },
  { label: "10:00 AM", value: "10:00" },
  { label: "11:00 AM", value: "11:00" },
  { label: "12:00 PM", value: "12:00" },
  { label: "1:00 PM", value: "13:00" },
  { label: "2:00 PM", value: "14:00" },
  { label: "3:00 PM", value: "15:00" },
  { label: "4:00 PM", value: "16:00" },
  { label: "5:00 PM", value: "17:00" },
  { label: "6:00 PM", value: "18:00" },
  { label: "7:00 PM", value: "19:00" },
  { label: "8:00 PM", value: "20:00" },
  { label: "9:00 PM", value: "21:00" },
  { label: "10:00 PM", value: "22:00" },
  { label: "11:00 PM", value: "23:00" },
  { label: "00:00 AM", value: "24:00" },
];

// ALL GIGS TABLE

export const GIGS_STATUS = {
  NOT_VERIFIED: 1,
  PROCESSED_PENDING: 2,
  PROCESSED_COMPLETE: 3,
  INELIGIBLE: 4,
  REJECTED: 5,
  PROCESSED_PARTIAL: 6,
  ARCHIVED: 7,
} as const;

export const STATUS_OPTIONS = [
  { value: "all", labelKey: "gigs:filter-status-all", labelDefault: "All" },
  { value: "not-verified", labelKey: "gigs:filter-status-not-verified", labelDefault: "Not Verified" },
  { value: "processed", labelKey: "gigs:filter-status-processed", labelDefault: "Processed" },
  { value: "ineligible", labelKey: "gigs:filter-status-ineligible", labelDefault: "Ineligible" },
  { value: "rejected", labelKey: "gigs:filter-status-rejected", labelDefault: "Rejected" },
  { value: "archived", labelKey: "gigs:filter-status-archived", labelDefault: "Archived" },
] as const;
